module.exports = __webpack_public_path__ + "static/media/Medal_medal.d9b75c4a.png";